export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/clothing_apparel.8eb668c.svg";